import styled, { createGlobalStyle } from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 45px;
`;

export const GlobalCss = createGlobalStyle`
  * {
    font-family: 'Roboto', sans-serif;
  }
`;
